import { apiService } from '../../_services/api.service'

const BASE = '/clinics/admin/carrier-configs/'

export const carrierCallApi = {
  list: () => apiService.get(BASE),
  detail: (id) => apiService.get(`${BASE}${id}/`),
  create: (data) => apiService.post(BASE, data),
  update: (id, data) => apiService.post(`${BASE}${id}/`, data),
  approve: (id) => apiService.post(`${BASE}${id}/approve/`),
  disable: (id) => apiService.post(`${BASE}${id}/disable/`),
  listRecordings: (id) => apiService.get(`${BASE}${id}/recordings/`),
  uploadRecording: (id, formData) => apiService.create_payment(`${BASE}${id}/recordings/`, formData),
  testCall: (id, policyId) => apiService.post(`${BASE}${id}/test-call/`, { policy_id: policyId }),
  // Carrier-auto-detect intake flow
  intakeUpload: (formData) => apiService.create_payment(`${BASE}intake/`, formData),
  intakeStatus: (recordingId) => apiService.get(`${BASE}intake/${recordingId}/`),
  bindRecordingToProvider: (recordingId, providerId) =>
    apiService.post(`${BASE}from-recording/${recordingId}/`, { provider_id: providerId }),
}
